import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import type {MessengerPresencePort} from './presence.port';
import {MemberStatus, MessengerMemberRef} from './messenger.models';
import {FIXTURE_STATUSES, fixturePick} from './messenger-fixture-data';

/** The presence port on the carbon mockup's data, for a dev build (ITP-E-194-02): one stable status per person. */
@Injectable({providedIn: 'root'})
export class MessengerPresenceFixture implements MessengerPresencePort {
  statuses(members: MessengerMemberRef[]): Observable<Record<string, MemberStatus>> {
    const statuses: Record<string, MemberStatus> = {};
    members.forEach(member => statuses[member.email.toLowerCase()] = fixturePick(member.email.toLowerCase(), FIXTURE_STATUSES));
    return of(statuses);
  }

  onlineCount(conversationId: string, members: MessengerMemberRef[]): Observable<number> {
    return this.statuses(members).pipe(map(statuses =>
      Object.values(statuses).filter(status => status.availability !== 'offline').length));
  }
}
